import { defineComponent, defineAsyncComponent, onMounted } from 'vue';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import componentPresenter from '@/presenters/component-presenter';
import InternalNotesInputCode from '@/presentation/components/internal-notes/internal-notes-input.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		TinyMCE: defineAsyncComponent(componentPresenter.loadTinyMCEComponent.bind(componentPresenter))
	},
	setup: () => {
		const code = new InternalNotesInputCode();

		onMounted(code.mounted.bind(code));

		return {
			isLazyLoading: componentPresenter.isLoading,
			isLoading: code.isLoading,
			internalNotes: code.internalNotes
		};
	}
});
